import { IonButton, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonList, IonRadio, IonRadioGroup, IonRow, IonSpinner, IonToolbar } from '@ionic/react';
import { searchOutline } from 'ionicons/icons';
import { useState } from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { IonModalWrapper } from './FormSelectable.styles';

interface IComponentProps {
  field?: ControllerRenderProps<FieldValues, string>;
  fieldKey?: string;
  itemKey: string;
  itemValue: string;
  itemValueSub?: string;
  items?: any[];

  allowSearch?: boolean;
  placeholder?: string;
  showLoading?: boolean;
  showModal?: boolean;

  itemDisabled?: (item: any) => boolean;

  handleSearch?: (arg: string) => void;
  handleDismiss?: () => void;
  handleSelection?: (value: any) => void;
}

const FormSelectableModal: React.FC<IComponentProps> = ({ field, fieldKey, itemKey, itemValue, itemValueSub, items, allowSearch, placeholder, showLoading, showModal, itemDisabled, handleSearch, handleDismiss, handleSelection }) => {
  const [searchValue, setSearchValue] = useState('');
  const fieldKeyClone = fieldKey || 'code';

  const handleDismissWrapper = () => {
    if (handleDismiss) {
      handleDismiss();
    }
    setSearchValue('');
  };

  const handleSelectionWrapper = (val: any, field?: ControllerRenderProps<FieldValues, string>) => {
    if (fieldKey) {
      // add the item value to the field property
      field?.onChange({
        ...val,
        [fieldKeyClone]: val[itemKey],
      });
    } else {
      field?.onChange(val[itemKey]);
    }

    if (handleSelection) {
      handleSelection(val);
      setSearchValue('');
    }
  };

  return (
    <IonModalWrapper
      isOpen={showModal}
      onDidDismiss={() => {
        if (showModal) {
          handleDismissWrapper();
        }
      }}>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButton className="toolbarButton" onClick={() => handleDismissWrapper()}>
            CANCEL
          </IonButton>
          {allowSearch && (
            <IonItem className="toolbarSearch" lines="none">
              <IonIcon icon={searchOutline} slot="start"></IonIcon>
              <IonInput
                onIonInput={(e) => {
                  const val = e.detail.value || '';
                  if (val !== searchValue) {
                    setSearchValue(val);
                    if (showModal) {
                      handleSearch && handleSearch(val);
                    }
                  }
                }}
                placeholder={placeholder || ''}
                value={searchValue}></IonInput>
            </IonItem>
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest">
        {showLoading && (
          <div className="loadingSpinnerContainer">
            <IonSpinner name="lines" />
          </div>
        )}
        {items?.length ? (
          <IonList>
            <IonRadioGroup value={field?.value ? field?.value[fieldKeyClone] : ''}>
              {items?.map((item, index) => {
                return (
                  <IonGrid key={item[itemKey]}>
                    <IonItem disabled={itemDisabled && itemDisabled(item)} onClick={() => handleSelectionWrapper(item, field)}>
                      <div className="ion-no-margin">
                        <IonRow>
                          <IonCol className="col-padding">{item[itemValue]}</IonCol>
                        </IonRow>
                        {itemValueSub && (
                          <IonRow>
                            <IonCol className="col-padding">{item[itemValueSub]}</IonCol>
                          </IonRow>
                        )}
                      </div>
                      <IonRadio mode="md" slot="start" color="primary" value={item[itemKey]}></IonRadio>
                    </IonItem>
                  </IonGrid>
                );
              })}
            </IonRadioGroup>
          </IonList>
        ) : (
          <></>
        )}
      </IonContent>
    </IonModalWrapper>
  );
};

export default FormSelectableModal;
